import {
  Component,
  HostListener,
  AfterViewInit,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Utility } from "../shared/utility/utility";
import { ProfileSettingService } from "../services/profile-setting.service";
import { UserDetailsService } from "../services/user-details.service";
import { EmitterService } from "../services/emitter.service";
import { myAccountTabs, myAccountTabsMobile } from "../shared/utility/config";
import * as $ from "jquery";
window['$'] = window['jQuery'] = $;
import * as _ from "underscore";
import { HostedCashierPaymentsService } from "../services/hosted-cashier-payments.service";
import { environment } from "../../environments/environment";
import { forkJoin, Subject } from "rxjs";
import { AjaxService } from "../services/ajax.service";
import { PnpZimplerService } from "../services/pnp-zimpler.service";
import { takeUntil } from "rxjs/operators";
import { BonusService } from "../app-myaccount/bonuses/services/bonus.service";

@Component({
  selector: "app-myaccount-header",
  templateUrl: "./myaccount-header.component.html",
  styleUrls: ["./myaccount-header.component.scss"],
})
export class MyaccountHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  windowType;
  userDetails;
  isUserLoggedIn;
  langCode;
  myAccountTabs;
  myAccountTabsMobile;
  activeTab;
  title;
  userCurrencySymbol;
  cashBalance;
  isRealUser;
  pendingWithDrawsAvailable = 0;
  piqObject = {};
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  activeMobileTab: string = "myaccount";
  isCountryAllowed: any;
    destroy$: Subject<boolean> = new Subject<boolean>();

  @HostListener("window:resize") onResize() {
    this.deviceType();
  }

  constructor(
    private emitterService: EmitterService,
    private userService: UserDetailsService,
    private router: Router,
    private utils: Utility,
    private profileSettingService: ProfileSettingService,
    private paymentService: HostedCashierPaymentsService,
    private ajaxService: AjaxService,
    private emitter: EmitterService,
    private pnpService: PnpZimplerService,
    private bonusService: BonusService
  ) {
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkPendingWithdrawals();
        this.activeTabName();
      }
    });

    this.userService.userBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe((message) => {
        this.cashBalance = this.userService.getUserCashBalance();
        this.checkWithdrawal();
      }
    );

    this.emitter.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isCountryAllowed = data;
    });

    this.emitter.myAccountActiveTabData$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.setActiveTab(data);
      this.scrollToTabs();
    });

    this.emitterService.txnComplete$.pipe(takeUntil(this.destroy$)).subscribe((loginStatus) => {
      this.checkPendingWithdrawals();
    });

    this.emitterService.userDataSource$.pipe(takeUntil(this.destroy$)).subscribe((userDataSource) => {
        if (userDataSource === "User Data Updated") {
          this.userDetails = this.userService.getUserProfileDetails();
                  }
      }
    );

    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe((loginStatus) => {
        this.isUserLoggedIn = loginStatus;
        this.userCurrencySymbol = this.userService.getUserCurrencySymbol();
      }
    );

    this.langCode = localStorage.getItem("langCode");
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe((langCode) => {
        this.langCode = langCode;
      }
    );

    this.myAccountTabs = myAccountTabs;
    this.myAccountTabsMobile = myAccountTabsMobile;

    this.checkPendingWithdrawals();
  }

  getWithdrawalTabs() {
    return myAccountTabsMobile.find((tab) => tab.id === "withdrawls");
  }

  resetMobileTabs() {
    let withdrawlTab = this.getWithdrawalTabs();
    withdrawlTab.hide = true;
  }

  checkPendingWithdrawals() {
    this.resetMobileTabs();
    const getTokenObservable = this.paymentService.getTokenPaymentIQ("cashier");
    const getProfileDataObservable = this.ajaxService.getProfileBalanceCurrency();

    forkJoin([getTokenObservable, getProfileDataObservable]).pipe(takeUntil(this.destroy$)).subscribe(async ([tokenData, profileData]:any) => {
      if (
        profileData &&
        profileData.profile &&
        profileData.profile.externalEcrId
      ) {
        this.userService.setUserCountry(profileData["countryCode"]);
        this.isRealUser =
          profileData && profileData.profile.userStatus === "real"
            ? true
            : false;
        this.cashBalance =
          profileData && profileData.profile.balanceDetails
            ? profileData.profile.balanceDetails.cash
            : 0;

        this.piqObject["userId"] = profileData.profile.externalEcrId;
        this.piqObject["sessionId"] = tokenData.token;
        this.piqObject["merchantId"] = environment.paymentIqMID;

        const getPendingWithdrawalObject = _.clone(this.piqObject);
        getPendingWithdrawalObject["method"] = "Withdrawal";
        getPendingWithdrawalObject["states"] = "WAITING_APPROVAL";

        let pendingWithDrawlsData = await this.paymentService
          .getPendingWithdrawal(getPendingWithdrawalObject)
          .toPromise();

        let withdrawlTab = this.getWithdrawalTabs();

        if (
          pendingWithDrawlsData &&
          pendingWithDrawlsData.success &&
          pendingWithDrawlsData.transactions &&
          pendingWithDrawlsData.transactions.length > 0
        ) {
          this.pendingWithDrawsAvailable =
            pendingWithDrawlsData.transactions.length;

          if (withdrawlTab !== undefined) {
            withdrawlTab.hide = false;
          }
        } else {
          this.pendingWithDrawsAvailable = 0;
        }
      }
    });
  }
  ngOnInit() {
    this.deviceType();
  }
  ngAfterViewInit() {
    this.userCurrencySymbol = this.userService.getUserCurrencySymbol();
    this.cashBalance = this.userService.getUserCashBalance();
    this.checkWithdrawal();
    this.activeTabName();

    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    if (this.isUserLoggedIn) {
      Promise.resolve(this.profileSettingService.getProfileData(false)).then(
        (profileData) => {
          this.userDetails = profileData;
        }
      );
    } else {
      this.router.navigate(["/" + this.langCode]);
    }
    setTimeout(() => {
      this.deviceType();
    });
  }

  deviceType() {
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }

  setActiveTab(tabID) {
    let tabFound = myAccountTabsMobile.find((tab) => tab.id === tabID);

    if (tabFound.id === "withdrawls") {
      let pathArr = tabFound.path.split("?");

      let uriPath = pathArr[0];
      let queryParamsStr = pathArr.length >= 2 ? pathArr[1] : null;

      if (queryParamsStr) {
        let params: any = this.utils.parseQuery(queryParamsStr);
        params.time=new Date().getTime();

        this.router.navigate([this.langCode + uriPath], {
          queryParams: params,
        }).then(()=>{
          history.replaceState(null,"", this.router.createUrlTree([this.langCode + uriPath]).toString())
        });
      } else {
        this.router.navigate([this.langCode + uriPath]);
      }

      return;
    }

    

    if (tabFound !== undefined) {
      if(tabID==='activebonuses') this.bonusService.broadRefreshEligibleBonus(true);

      this.title = tabFound.name;
      this.activeMobileTab = tabID;
    }

  }

  resetMobileActiveTab(){
    //Get First  Tab which is myaccount in this case
    let tabFound = myAccountTabsMobile[0];
    this.title = tabFound.name;
    this.activeMobileTab = tabFound.id;
  }

  navigateTo(name, path) {
    this.activeTab = path;
    this.title = name;
    this.router.navigate([this.langCode + path]);
    $(".myaccount-tabs-list").animate({ scrollLeft: 0 }, "smooth");
  }

  activeTabName() {
    this.activeTab = this.langCode
      ? window.location.pathname.slice(3)
      : window.location.pathname;
    _.each(myAccountTabs, (item) => {
      if (item.path === this.activeTab) {
        this.title = item.name;
        return;
      }
    });
  }

  scrollToTabs() {
    setTimeout(() => { 
      let accountTabs: HTMLElement = document.querySelector("#my-account-tabs");
      if (accountTabs !== null && this.activeMobileTab !== 'myaccount') {
          window.scrollTo({
          top: accountTabs.offsetTop - 20,
          behavior: "smooth",
        });
      }

      let tabsListWrap = $('.myaccount-tabs-list');
      if(tabsListWrap) {
        let tabsWidth =  tabsListWrap.find('button').width();
        let selectedTabIndex = tabsListWrap.find('button').not('.hide').index(tabsListWrap.find('.btn.active'));
        let selectedTabsPos = 0;
        if(tabsWidth && selectedTabIndex > 0) {
          selectedTabsPos = (tabsWidth * selectedTabIndex);
        }
        tabsListWrap.scrollLeft(selectedTabsPos);
      }
    });
  }


  doDeposit() {
    if(!this.userService.checkIsPNPUser()){
      this.emitter.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "deposit" });
    } else {
      this.pnpService.openZimplerDeposit()
    }
  }

  checkWithdrawal() {
    Promise.resolve(this.profileSettingService.getProfileData(true)).then(
      (profileData) => {
        this.userService.setUserCountry(profileData["country"]);
        this.userDetails = this.userService.getUserProfileDetails();
        this.isRealUser =
          this.userDetails && this.userDetails.userStatus === "real"
            ? true
            : false;
      }
    );
  }

  goToAllGames() {
    this.router.navigate([this.langCode + "/casino/allgames"], {
      queryParams: { gameTab: "allgames" },
    });
  }

  doWithdraw() {
    if ((this.isRealUser && this.cashBalance > 0) && !this.userService.checkIsPNPUser()) {
      this.emitterService.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "withdrawal" });
    } else {
      this.pnpService.openZimplerWithDraw()
    }

    this.resetMobileActiveTab();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
